import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import AdminDashboard from './components/AdminDashboard';
import BuyerRecords from './components/BuyerDashboard';
import FinanceDashboard from './components/FinanceDashboard';
import NavBar from './components/NavBar';
import Sidebar from './components/SideBar';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import dayjs from 'dayjs';

const AppContent = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState({ startDate: dayjs(), endDate: dayjs() });
  const location = useLocation();

  // Секретный ключ для доступа к /finceone
  const SECRET_KEY = 'Av7TeAm2025FiNance';
  
  // Разрешённые пользователи для /finceone (username или email)
  const ALLOWED_USERS = ['admin', 'anton.makemoney@gmail.com'];

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const handleLogin = (loggedInUser) => {
    localStorage.setItem('user', JSON.stringify(loggedInUser));
    setUser(loggedInUser);
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
  };

  const handleMenuClick = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleDateRangeChange = (range) => {
    setSelectedDateRange({
      startDate: dayjs(range.startDate),
      endDate: dayjs(range.endDate)
    });
  };

  const menuItems = [
    { label: 'Главная', onClick: () => console.log('Главная') },
    { label: 'Настройки', onClick: () => console.log('Настройки') },
    { label: 'Профиль', onClick: () => console.log('Профиль') },
  ];

  // Ждём загрузку user из localStorage
  if (loading) {
    return null;
  }

  // Роут /finceone - только для разрешённых пользователей + секретный ключ
  if (location.pathname === '/finceone') {
    const params = new URLSearchParams(location.search);
    const key = params.get('key');

    // Проверка секретного ключа
    if (key !== SECRET_KEY) {
      window.location.href = 'https://grasjda.online';
      return null;
    }

    // Проверка авторизации
    if (!user) {
      window.location.href = 'https://grasjda.online/login';
      return null;
    }

    // Проверка роли admin
    if (user.role !== 'admin') {
      window.location.href = `https://grasjda.online/buyer/${user.name}`;
      return null;
    }

    // Проверка по списку разрешённых пользователей
    if (!ALLOWED_USERS.includes(user.username) && !ALLOWED_USERS.includes(user.email)) {
      window.location.href = 'https://grasjda.online/admin';
      return null;
    }

    return <FinanceDashboard />;
  }

  return (
    <div>
      {!user ? (
        <Routes>
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      ) : (
        <>
          <NavBar onMenuClick={handleMenuClick} onLogout={handleLogout} />
          <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} menuItems={menuItems} />
          <Routes>
            {user.role === 'admin' ? (
              <Route path="/admin" element={<AdminDashboard userId = {user.username} dateRange={selectedDateRange} onDateRangeChange={handleDateRangeChange}/>} />
            ) : (
              <Route path={`/buyer/${user.name}`} element={<BuyerRecords username={user.name} userId = {user.username} dateRange={selectedDateRange} onDateRangeChange={handleDateRangeChange} />} />
            )}
            <Route path="*" element={<Navigate to={user.role === 'admin' ? '/admin' : `/buyer/${user.name}`} />} />
          </Routes>
        </>
      )}
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
